import { NGROK } from "../../../../APIs";
import { apiClient } from "../../../../utils/apiClient";


export const getGCPAllVms = async (latestTenant: string, latestprojectId: string) => {

    let url = `${NGROK}/api/gcp/resource/getAllPublishVirtualMachine?tenantName=${latestTenant}&projectId=${latestprojectId}`

    const data = await apiClient({
        method: "GET",
        url: url
    });

    const flattenedData = Object.values(data).flatMap((item) => item);
    return flattenedData;
};

export const getGCPAllStorages = async (latestTenant: string, latestprojectId: string) => {
    let url = `${NGROK}/api/gcp/resource/getAllPublishStorageBuckets?tenantName=${latestTenant}&projectId=${latestprojectId} `;
    const data = await apiClient({
        method: "GET",
        url: url
    });
    return data;
};

export const getGCPAllDatabases = async (latestTenant: string, latestprojectId: string) => {
    let url = `${NGROK}/api/gcp/resource/getAllPublishDatabases?tenantName=${latestTenant}&projectId=${latestprojectId}`;
    const data = await apiClient({
        method: "GET",
        url: url
    });
    return data;
};

export const getGCPAllCluster = async (latestTenant: string, latestprojectId: string) => {
    let url = `${NGROK}/api/gcp/resource/getAllPublishKubernetesClusters?tenantName=${latestTenant}&projectId=${latestprojectId}`;
    const data = await apiClient({
        method: "GET",
        url: url
    });
    return data;
};

export const getGCPAllRoles = async (latestTenant: string, latestprojectId: string, selectedResourceType: string) => {
    let url = `${NGROK}/api/gcp/resource/getApplicableRoles?tenantName=${latestTenant}&projectId=${latestprojectId}`;
    if (selectedResourceType === "vm") {
        url += `&resourceType=VIRTUAL_MACHINE `
    } else if (selectedResourceType === "kubernetes") {
        url += `&resourceType=KUBERNETES_CLUSTER `
    } else if (selectedResourceType === "database") {
        url += `&resourceType=DATABASE `
    } else if (selectedResourceType === "storage") {
        url += `&resourceType=STORAGE_BUCKET `
    }
    const data = await apiClient({
        method: "GET",
        url: url
    });
    return data;
};


export const fetchGCPUserConfig = async (latestTenant: string, email: string) => {
    let url = `${NGROK}/api/gcp/getGcpUserConfig?tenantName=${latestTenant}&tenantEmail=${email}`;
    const data = await apiClient({
        method: "GET",
        url: url
    });
    return data;
};


export const submitForm = async (payload: any) => {
    let url = `${NGROK}/api/gcp/resource/gcp-request-access`;
    const data = await apiClient({
        method: "POST",
        url: url,
        data: payload
    });
    return data;
};

export const configureGCPUser = async (latestTenant: string, email: string, gcpUsername: string, gcpAccountemail: string) => {
    let url = `${NGROK}/api/gcp/addGcpUserConfig?tenantName=${latestTenant}&tenantEmail=${email}&gcpUserName=${gcpUsername}&gcpAccountEmail=${gcpAccountemail}`;
    const data = await apiClient({
        method: "POST",
        url: url,
    });

    return data;
};


export const specificGCPUser = async (latestTenant: string, projectId: string, gcpAccountEmail: string) => {
    let url = `${NGROK}/api/gcp/fetch-users-details?projectId=${projectId}&tenanatName=${latestTenant}&gcpUserEmail=${gcpAccountEmail}`;
    const data = await apiClient({
        method: "GET",
        url: url,
    });

    return data;
}